import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { useApi } from '../../hooks/useApi';

function ResetPasswordPage() {
    const { request } = useApi();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [done, setDone] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!token) {
            setMessage('В ссылке нет токена сброса.');
            return;
        }

        if (password.length < 8) {
            setMessage('Новый пароль должен быть не короче 8 символов.');
            return;
        }

        if (password !== passwordRepeat) {
            setMessage('Пароли не совпадают.');
            return;
        }

        setBusy(true);
        setMessage('');

        try {
            await request('/api/v1/auth/password-reset/confirm', {
                method: 'POST',
                body: JSON.stringify({
                    token,
                    new_password: password,
                }),
            });
            setDone(true);
            setMessage('Пароль обновлен. Теперь можно войти с новым паролем.');
            setPassword('');
            setPasswordRepeat('');
        } catch (error) {
            setMessage(error.message || 'Не удалось обновить пароль.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="app">
            <main className="app__shell">
                <section className="panel panel--auth">
                    <h1>Сброс пароля</h1>
                    {!done && (
                        <form className="panel__form" onSubmit={handleSubmit} noValidate>
                            {!token && (
                                <p>В ссылке нет токена. Запросите новую ссылку для сброса пароля.</p>
                            )}

                            <label>
                                Новый пароль
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(event) => setPassword(event.target.value)}
                                    minLength={8}
                                    required
                                />
                            </label>

                            <label>
                                Повторите пароль
                                <input
                                    type="password"
                                    value={passwordRepeat}
                                    onChange={(event) => setPasswordRepeat(event.target.value)}
                                    minLength={8}
                                    required
                                />
                            </label>

                            <button type="submit" disabled={busy || !token}>
                                Обновить пароль
                            </button>
                        </form>
                    )}

                    {message && <p>{message}</p>}

                    <Link className="button-link" to="/">
                        Вернуться на главную
                    </Link>
                </section>
            </main>
        </div>
    );
}

export default ResetPasswordPage;
